export default function Services() {
  const services = [
    {
      icon: 'ri-customer-service-2-line',
      tag: 'AI-Enhanced',
      title: 'Customer Experience (CX)',
      description: 'Omni-channel AI-assisted support across chat, voice, social, and email — delivering faster resolutions and higher satisfaction at scale.'
    },
    {
      icon: 'ri-robot-2-line',
      tag: 'AI-Powered',
      title: 'Back Office Automation',
      description: 'Finance, accounting, HR, payroll, content moderation, and data operations — intelligently automated to reduce errors and cut processing time.'
    },
    {
      icon: 'ri-line-chart-line',
      tag: 'AI-Driven',
      title: 'Sales & Lead Generation',
      description: 'AI-qualified pipelines and smart outreach that identify high-intent prospects, accelerate conversions, and grow revenue predictably.'
    },
    {
      icon: 'ri-cpu-line',
      tag: 'AI-Assisted',
      title: 'Technical Support',
      description: 'Intelligent triage and resolution workflows that route issues to the right expert instantly, reducing handle time and boosting first-contact resolution.'
    },
    {
      icon: 'ri-team-line',
      tag: 'Flexible Delivery',
      title: 'Remote Teams',
      description: 'Fully managed, AI-augmented remote teams that integrate seamlessly with your operations — scalable up or down within days, not months.'
    },
    {
      icon: 'ri-shield-check-line',
      tag: 'Compliant',
      title: 'Secure & Compliant Operations',
      description: 'SOC 2, HIPAA, PCI-DSS, and GDPR-ready infrastructure with AI-powered monitoring to protect your data and your customers\' trust.'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-blue-50 border border-blue-100 rounded-full px-4 py-2 mb-4">
            <i className="ri-sparkling-line text-blue-600 text-sm"></i>
            <span className="text-sm font-medium text-blue-700">What We Do</span>
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Global Outsourcing, <span className="text-blue-600">Powered by AI</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            We don't just provide outsourcing — we deliver intelligent operations that eliminate waste, automate the repetitive, and free your team to focus on growth.
          </p>
        </div>

        {/* AI Efficiency strip */}
        <div className="bg-gradient-to-r from-[#0a0f1e] to-blue-900 rounded-2xl p-8 mb-12 flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 flex items-center justify-center bg-blue-500/20 rounded-xl border border-blue-500/30">
              <i className="ri-flashlight-line text-2xl text-blue-400"></i>
            </div>
            <div>
              <div className="text-xs font-semibold text-blue-400 uppercase tracking-widest mb-1">AI Efficiency &amp; Growth</div>
              <h3 className="text-2xl font-bold text-white">Eliminate. Automate. Reallocate.</h3>
            </div>
          </div>
          <div className="grid grid-cols-3 gap-8 text-center">
            <div>
              <div className="w-10 h-10 flex items-center justify-center bg-red-500/20 rounded-lg mx-auto mb-2">
                <i className="ri-delete-bin-line text-red-400"></i>
              </div>
              <div className="text-white font-semibold text-sm">Eliminate</div>
              <p className="text-gray-400 text-xs mt-1">Remove wasted processes and costs that slow execution</p>
            </div>
            <div>
              <div className="w-10 h-10 flex items-center justify-center bg-yellow-500/20 rounded-lg mx-auto mb-2">
                <i className="ri-settings-3-line text-yellow-400"></i>
              </div>
              <div className="text-white font-semibold text-sm">Automate</div>
              <p className="text-gray-400 text-xs mt-1">Route work to the right people and AI to minimise scale costs</p>
            </div>
            <div>
              <div className="w-10 h-10 flex items-center justify-center bg-green-500/20 rounded-lg mx-auto mb-2">
                <i className="ri-arrow-left-right-line text-green-400"></i>
              </div>
              <div className="text-white font-semibold text-sm">Reallocate</div>
              <p className="text-gray-400 text-xs mt-1">Redirect workflows and talent to drive speed and growth</p>
            </div>
          </div>
        </div>

        {/* Service cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service, index) => (
            <div
              key={index}
              className="group bg-white border border-gray-200 rounded-xl p-8 hover:border-blue-500 hover:shadow-xl transition-all duration-300 cursor-pointer"
            >
              <div className="flex items-start justify-between mb-6">
                <div className="w-14 h-14 flex items-center justify-center bg-blue-50 rounded-lg group-hover:bg-blue-600 transition-colors">
                  <i className={`${service.icon} text-2xl text-blue-600 group-hover:text-white transition-colors`}></i>
                </div>
                <span className="text-xs font-semibold text-blue-600 bg-blue-50 px-2 py-1 rounded-full border border-blue-100">
                  {service.tag}
                </span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">{service.title}</h3>
              <p className="text-gray-600 leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a href="/services" className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-700 font-semibold text-lg transition-colors">
            View All AI Solutions
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
